import React from 'react';
import { Image, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import nothingHere from '../../nothing-here.png';
import colors from '../../styles/theme/foundation/colors';

const DeactivatedUserPage = ({ companyName }) => (
  <div>
    <Image margin="auto" src={nothingHere} />
    <Text color={colors.greyScale['500']} mt={4} textStyle="bodyXl500">
      {`You've been deactivated as a user for ${companyName}`}
    </Text>
    <Text color={colors.greyScale['400']} textStyle="bodySm500">
      Please contact your company admin if you are receiving this message in error.
    </Text>
  </div>
);

DeactivatedUserPage.propTypes = { companyName: PropTypes.string };

export default DeactivatedUserPage;
